import React from "react";
import "./CSS/card.css";
import { BiLinkExternal } from "react-icons/bi";

export default function BlogItem(props) {
  return (
    <div className="card h-100">
      <img src={props.imageUrl} className="card-img-top" alt={props.title} />
      <div className="card-body">
        <h4 className="card-title">{props.title}</h4>
        <p className="card-text clamp-3">{props.description}</p>
      </div>
      <div className="card-footer">
        <a
          href={props.project_url}
          target="_blank"
          rel="noreferrer"
          className="card-link"
        >
          Read Article
          <BiLinkExternal />
        </a>
      </div>
    </div>
  );
}
